import React, { Fragment } from "react";

import { TableExpandableCard } from "../../../../../../components/table/components/TableExpandableCard";
import { DeviceNameCellMobile } from "../../../../../../components/table";
import { DeviceWithType } from "../../../../../../components/devices/DeviceWithType";
import { InfectionsSummary } from "../../../infectionsSummary";
import { ClickAbsorber } from "../../../../../../components/clickAbsorber/ClickAbsorber";
import { InfectedDevicesActionsDropdown } from "../infectedDevicesActionsDropdown";

export const TableCard = ({
  isExpanded,
  type,
  manufacturer,
  name,
  id,
  infections,
}) => {
  return (
    <TableExpandableCard
      isExpanded={isExpanded}
      content={
        <Fragment>
          <DeviceNameCellMobile name={name} />
          <DeviceWithType type={type} identifier={id} />
          <InfectionsSummary infections={infections} />
        </Fragment>
      }
      aside={
        <ClickAbsorber>
          <InfectedDevicesActionsDropdown
            device={{ type, manufacturer, name, identifiers: [id] }}
          />
        </ClickAbsorber>
      }
    />
  );
};
